import Link from 'next/link';
import { useRouter } from 'next/router';

import { ReactElement } from 'react';
import { useQuery } from 'react-query';

import { AxiosError } from 'axios';

import { alertError, alertErrorCustom } from '@common/modal';
import { css } from '@emotion/react';
import { SearchType } from '@type/web/fraud';

import useGoBack from '@lib/hook/useGoBack';
import usePortal from '@lib/hook/usePortal';

import FraudHead from '@components/web/Fraud/FraudHead/FraudHead';
import FraudSearchResult from '@components/web/Fraud/FraudSearchResult/FraudSearchResult';
import useFraudSearchForm from '@components/web/Fraud/hook/useFraudSearchForm';
import BasicLayout from '@components/web/Layout/BaisicLayout';
import IconLoading from '@components/web/common/icons/IconLoading';

export default function FraudSearchResultPage(): ReactElement {
  const {
    query: { inputValue, type },
  } = useRouter();

  const goBack = useGoBack();

  const { getFraudSearchResult } = useFraudSearchForm();

  const { isFetching, data } = useQuery(
    'fraud',
    () => getFraudSearchResult(inputValue as string, type as SearchType),
    {
      enabled: !!inputValue && !!type,
      onError(error: AxiosError) {
        if (error?.response?.status === 429) {
          alertErrorCustom({
            title: '경고',
            content: (error as any)?.response.data.meta.message,
            onOk: goBack,
          });
        } else
          alertError({
            onOk: goBack,
          });
      },
    },
  );

  return (
    <BasicLayout
      headerOptions={{
        isShowBackground: true,
        types: [{ type: 'primary' }, { type: 'navigation' }],
      }}
    >
      {isFetching ? (
        <IconLoading type="CenterLayout" />
      ) : (
        data && (
          <div css={container}>
            <FraudHead />
            <FraudSearchResult result={data} />
          </div>
        )
      )}
    </BasicLayout>
  );
}

const container = css`
  max-width: 1200px;
  min-height: 100%;
  margin: 0 auto;
`;
